import type { RequestTeamOverlap } from '../../../utils/findRequestTeamOverlaps';

interface TeamOverlapNoticeProps {
  overlaps: RequestTeamOverlap[];
}

function formatOverlapDates(start: Date | null, end: Date | null): string {
  if (!start || !end) return '';
  const startStr = start.toLocaleDateString('pt-BR');
  const endStr = end.toLocaleDateString('pt-BR');
  return `${startStr} até ${endStr}`;
}

export function TeamOverlapNotice({ overlaps }: TeamOverlapNoticeProps) {
  if (overlaps.length === 0) return null;

  return (
    <div className="rounded-lg border border-indigo-200 bg-indigo-50 p-3">
      <h4 className="text-xs font-semibold text-indigo-900 font-montserrat mb-2">
        Cobertura do time
      </h4>
      <ul className="space-y-1">
        {overlaps.map((overlap) => (
          <li key={`${overlap.collaboratorId}_${overlap.proximity}`}>
            {overlap.proximity === 'overlap' && overlap.overlapStart && overlap.overlapEnd ? (
              <p className="text-xs text-indigo-700">
                ↳ Sobrepõe {overlap.overlapDays} dia{overlap.overlapDays > 1 ? 's' : ''} com{' '}
                <span className="font-semibold">{overlap.collaboratorName}</span> (
                {formatOverlapDates(overlap.overlapStart, overlap.overlapEnd)})
              </p>
            ) : overlap.proximity === 'nearby' ? (
              <p className="text-xs text-indigo-700">
                ↳ Fica a {overlap.gapDays} dia{overlap.gapDays > 1 ? 's' : ''} das férias de{' '}
                <span className="font-semibold">{overlap.collaboratorName}</span>
              </p>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
